import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Checkbox from '@zg-rentals/multibrand-ui/lib/Checkbox';
import HR from '@zg-rentals/multibrand-ui/lib/HR';

import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';

import UserManagementActions from 'app/shared/actions/UserManagementActions';

import './style.scss';

const { COMPANY_ADMIN, COMPANY_USER } = UserPermissionsConstants.PERMISSIONS;

const propTypes = {
    onNextStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const Role = ({
    onNextStep,
    onCancel,
    dispatch,
    currentUser,
    onBack,
    handleSaveComplete,
}) => {
    const { isInvitation } = currentUser;
    const isAdmin = currentUser.permissions[COMPANY_ADMIN];
    const isUser = !isAdmin && currentUser.permissions[COMPANY_USER];
    const isUserTypeSet = currentUser.permissions[COMPANY_ADMIN] || currentUser.permissions[COMPANY_USER];

    const handleSetAdmin = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [COMPANY_ADMIN]: true,
            [COMPANY_USER]: false,
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    };

    const handleSetUser = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [COMPANY_ADMIN]: false,
            [COMPANY_USER]: true,
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    };

    return (
        <div className="AddUserStepOne">
            <Row>
                <Col>
                    <Text type="h3">Select user role</Text>
                </Col>
            </Row>
            <Row>
                <Col className="Role-header">
                    <Text type="h4" className="Role-title">
                        {`Do you want to make ${currentUser.userName} a company admin, or a user?`}
                    </Text>
                </Col>
            </Row>
            <Row className="Role-padding-top">
                <Col className="AddUserPage-questions">
                    <Checkbox
                        labelTextType="body"
                        onChange={handleSetAdmin}
                        checked={isAdmin}
                    >
                        <div>
                            <Text
                                className="Checkbox-label"
                                type="body"
                            >
                                Company Admin
                            </Text>
                            <Text
                                type="body"
                                className="Checkbox-description"
                            >
                                Full access to properties and features. Can invite others.
                            </Text>
                        </div>
                    </Checkbox>
                    <Checkbox
                        onChange={handleSetUser}
                        labelTextType="body"
                        checked={isUser}
                    >
                        <div>
                            <Text
                                className="Checkbox-label"
                                type="body"
                            >
                                User
                            </Text>
                            <Text
                                type="body"
                                className="Checkbox-description"
                            >
                                Customizable access to properties and features. Cannot invite others.
                            </Text>
                        </div>
                    </Checkbox>
                </Col>
            </Row>
            <HR />
            <div className="Questions-footer">
                <Link className="Role-button" onClick={onCancel}>
                    Cancel
                </Link>
                <div>
                    <Link className="Questions-button" onClick={onBack}>
                        Back
                    </Link>
                    {isInvitation || (!isAdmin && !isInvitation)
                        ? (
                            <Button type="primary" onClick={onNextStep} disabled={!isUserTypeSet}>
                                Continue
                            </Button>
                        )
                        : (
                            <Button
                                type="primary"
                                onClick={() => dispatch(UserManagementActions.editableUserSave())
                                    .then(handleSaveComplete)}
                            >
                                Save
                            </Button>
                        )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    currentUser: state.userManagement.currentUser,
});

Role.propTypes = propTypes;

export default connect(mapStateToProps)(Role);
